var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display.length > 0)?_c('div',{staticClass:"info_table"},[_c('div',{staticClass:"item"},[_vm._v("总和:"+_vm._s(_vm.display[0]))]),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.display[1]))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }